// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.aHtS932zR_tZ_bsHvJlG {
  display: flex;
}
.aHtS932zR_tZ_bsHvJlG.tclA2__vgfFauegy5nbG {
  background-color: #fae5e5;
  border-right: 2px solid #d00000;
}
.aHtS932zR_tZ_bsHvJlG.tMAs9ZBIElOuquitcMLa {
  background-color: #e5fae5;
  border-right: 2px solid #3a852b;
}
.aHtS932zR_tZ_bsHvJlG.YG2uZ53Qs1XkaloljsQf {
  background-color: #f2f2f2;
  border-right: 2px solid #202020;
}
.aHtS932zR_tZ_bsHvJlG.tSTM9a6ZQJP8VcUYRifq {
  background-color: #faf2e5;
  border-right: 2px solid #ff8000;
}
.aHtS932zR_tZ_bsHvJlG .PYO39dKMQIAUTTGvKOv7 {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 10px;
  text-align: center;
  gap: 4px;
  overflow: hidden;
  white-space: nowrap;
}
.aHtS932zR_tZ_bsHvJlG .uQ5RqtBs05R8uVkZhN4a {
  width: 45px;
  margin-bottom: 6px;
}`, "",{"version":3,"sources":["webpack://./tcbase/static/js2/modules/commons/header/classification_image/classification-image.module.scss"],"names":[],"mappings":"AACA;EACE,aAAA;AAAF;AAEE;EACE,yBAAA;EACA,+BAAA;AAAJ;AAGE;EACE,yBAAA;EACA,+BAAA;AADJ;AAIE;EACE,yBAAA;EACA,+BAAA;AAFJ;AAKE;EACE,yBAAA;EACA,+BAAA;AAHJ;AAME;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,aAAA;EACA,kBAAA;EACA,QAAA;EACA,gBAAA;EACA,mBAAA;AAJJ;AAOE;EACE,WAAA;EACA,kBAAA;AALJ","sourcesContent":["@import \"/tcbase/static/style/settings/settings.rl.variables.scss\"; @import \"/tcbase/static/style/settings/settings.bs.variables.scss\";\n.classification_image {\n  display: flex;\n\n  &.malicious {\n    background-color: #fae5e5;\n    border-right: 2px solid $threat-status-malicious;\n  }\n\n  &.goodware {\n    background-color: #e5fae5;\n    border-right: 2px solid $threat-status-goodware;\n  }\n\n  &.unknown {\n    background-color: #f2f2f2;\n    border-right: 2px solid $threat-status-unknown;\n  }\n\n  &.suspicious {\n    background-color: #faf2e5;\n    border-right: 2px solid $threat-status-suspicious;\n  }\n\n  .wrapper {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    padding: 10px;\n    text-align: center;\n    gap: 4px;\n    overflow: hidden;\n    white-space: nowrap;\n  }\n\n  .image {\n    width: 45px;\n    margin-bottom: 6px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"classification_image": `aHtS932zR_tZ_bsHvJlG`,
	"malicious": `tclA2__vgfFauegy5nbG`,
	"goodware": `tMAs9ZBIElOuquitcMLa`,
	"unknown": `YG2uZ53Qs1XkaloljsQf`,
	"suspicious": `tSTM9a6ZQJP8VcUYRifq`,
	"wrapper": `PYO39dKMQIAUTTGvKOv7`,
	"image": `uQ5RqtBs05R8uVkZhN4a`
};
export default ___CSS_LOADER_EXPORT___;
